import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ILead, ILeadInput } from '@ebb-v2/ebb-integration';

@Injectable({
  providedIn: 'root'
})
export abstract class LeadApiService {

  abstract getLead(id: string): Observable<ILead>;
  abstract saveLead(lead: ILeadInput): any;
}
